import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ConstruccionComponent } from './components/construccion/construccion.component';
import { ConsultaSaldoComponent } from './components/consulta-saldo/consulta-saldo.component';
import { NoticiasComponent } from './components/noticias/noticias.component';
import { MensajeComponent } from './components/mensaje/mensaje.component';
import { PredialComponent } from './components/predial/predial.component'; 
import { CiacComponent } from './components/ciac/ciac.component';
import { DesgloseSaldoComponent } from './components/desglose-saldo/desglose-saldo.component';
import { TransparenciaComponent } from './components/transparencia/transparencia.component';
import { QuejatelComponent } from './components/quejatel/quejatel.component';
import { ConvocatoriasComponent } from './components/convocatorias/convocatorias.component';
import { CabildoComponent } from './components/cabildo/cabildo.component';

import { PredialService } from "./servicios/predial.service";
import { CiacService } from "./servicios/ciac.service";
import { BuzonService } from './servicios/buzon.service';


import { FormsModule }   from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalModule } from 'ngx-bootstrap';
import { NgSelectModule } from "@ng-select/ng-select";
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgxMaskModule } from 'ngx-mask'
import { NgwWowModule } from "ngx-wow";
import { NgxCaptchaModule } from 'ngx-captcha';
import { InformacionComponent } from './components/informacion/informacion.component';
import { SolicitudComponent } from './components/solicitud/solicitud.component';
import { BecasComponent } from './components/becas/becas.component';
import { EducacionComponent } from './components/educacion/educacion.component';
import { ResultadosComponent } from './components/resultados/resultados.component';
import { ResultadosdetalleComponent } from './components/resultadosdetalle/resultadosdetalle.component';
import { VariosComponent } from './components/varios/varios.component';
import { InternetmunicipalComponent } from './components/internetmunicipal/internetmunicipal.component';
import { PropuestasComponent } from './components/propuestas/propuestas.component';
import { ApoyosComponent } from './components/apoyos/apoyos.component';







@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    HeaderComponent,
    FooterComponent,
    ConstruccionComponent,
    NoticiasComponent,
    MensajeComponent,
    PredialComponent,
    ConsultaSaldoComponent,
    DesgloseSaldoComponent,
    CiacComponent,
    TransparenciaComponent,
    QuejatelComponent,
    ConvocatoriasComponent,
    CabildoComponent,
    InformacionComponent,
    SolicitudComponent,
    BecasComponent,
    EducacionComponent,
    ResultadosComponent,
    ResultadosdetalleComponent,
    VariosComponent,
    InternetmunicipalComponent,
    PropuestasComponent,
    ApoyosComponent
  
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    NgSelectModule,
    FormsModule,
    ModalModule.forRoot(),
    NgxMaskModule.forRoot(),
    LeafletModule,
    NgwWowModule,
    NgxCaptchaModule
  ],
  providers: [PredialService,
              CiacService,
              BuzonService,
              BsModalService],
  bootstrap: [AppComponent]
})
export class AppModule { }
